import { PaymentReportRequest } from './../model/activity-model';
import { CommonDataDTO } from './../../requests/model/combos-model';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { dataPrint, PaymentReport, PaymentReportsResponse } from '../model/activity-model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import * as FileSaver from 'file-saver';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { MAX_SELECTOR_DATA } from '@app/@core/constants/material-custom.constants';
import { ActivityStore } from '../activity-services/activity.store';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { Credentials } from '@app/@core/models/login-models';
import {
  BUSINESS_DIRECTOR,
  CHAIN,
  MACRO_CHAIN,
  MACRO_OFFICE,
  OFFICE_DIRECTOR,
} from '@app/@core/constants/users.constants';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';

const FORM_PARAM_MACRO_CHAIN = 'macroChain';
const FORM_PARAM_MACRO_OFFICE = 'macroOffice';
const NAMEPAYMENTSHEETSPANISH = 'HojaDePago_';
const NAMEPAYMENTSHEETCATALAN = 'FullDePagament_';
const SPANISHLANGUAGE = 'es-ES';

import { DatepickerUtilsService } from '@shared/services/utils/datepicker-utils.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import { TranslateService } from '@ngx-translate/core';
import { FINANCIAL_PRODUCT_AUTO } from '@app/@core/constants/requests.constants';

@UntilDestroy()
@Component({
  selector: 'app-payment-reports',
  templateUrl: './payment-reports.component.html',
  styleUrls: ['./payment-reports.component.scss'],
})
export class PaymentReportsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public searchDataForm: FormGroup;
  public establishmentsList: CommonDataDTO[];
  public prescriptorsList: CommonDataDTO[];
  macroChainList: CommonDataDTO[] = [];
  macroOfficeList: CommonDataDTO[] = [];
  public currentDate: Date = new Date();
  public minDate: Date = new Date('1/1/1900');
  pageSize: number = 100;
  public maxFinalDate: Date;
  private userInfo: Credentials;
  private isCheckAllEstablishment: boolean = false;
  private isCheckAllPrescriber: boolean = false;
  private chainId: string = '';
  private officeId: string = '';
  public displayedColumns: string[] = [
    'digitalsignature',
    'code',
    'operative',
    'paymentDate',
    'beneficiary',
    'import',
    'holder',
    'description',
    'lot',
    'printPayment',
  ];

  public head: string[][];
  public allData: any[] = [];
  public dataSource = new MatTableDataSource<PaymentReport>();
  public reports: PaymentReportsResponse = null;
  checkedDateMonth = false;
  searchParamsExcel: PaymentReportRequest;
  pageEvent: PageEvent;
  page: number = 1;

  isMacroOfficeUser: boolean = false;
  isMacroChainUser: boolean = false;
  isBusinessDirector: boolean = false;

  selectedAllEstablishments = false;
  showSelectAllCheckboxEstablishment = false;
  selectedAllPrescribers = false;
  showSelectAllCheckboxPresciber = false;

  constructor(
    private formBuilder: FormBuilder,
    private customValidators: CustomValidatorsService,
    private activityStore: ActivityStore,
    private dialog: MatDialog,
    private cdref: ChangeDetectorRef,
    private datePipe: DatePipe,
    private excelService: ExcelService,
    private combosStore: CombosStore,
    private loaderGenericService: LoaderGenericService,
    private datepickerUtils: DatepickerUtilsService,
    private translateService: TranslateService
  ) {
    let dataString: string = localStorage.getItem('credentials');
    this.userInfo = JSON.parse(dataString);

    this.translateService.onLangChange.subscribe(() => {
      this.head = this.updateTableHeader(false);
    });
  }

  ngOnInit(): void {
    this.head = this.updateTableHeader(false);
    this.searchDataForm = this.formBuilder.group(
      {
        initialDate: ['', [Validators.required, this.customValidators.checkIsFutureDate]],
        finalDate: [{ value: '' }, [Validators.required, this.customValidators.checkIsFutureDate]],
        prescriptor: ['', Validators.required],
        establishment: ['', Validators.required],
      },
      { validators: [this.customValidators.isDateValid('initialDate', 'finalDate', 'dateInvalid')] }
    );

    this.searchDataForm.controls.prescriptor.valueChanges.subscribe((value) => {
      if (value && this.searchDataForm.controls.prescriptor.enabled) {
        const request = { listPrescribers: value, officeId: this.officeId };
        console.log(this.searchDataForm.controls.prescriptor);
        console.log('prescriber length: ', this.searchDataForm.controls.prescriptor?.value.length);
        console.log('prescriber list: ', this.prescriptorsList.length);

        if (this.searchDataForm.controls.prescriptor?.value.length === this.prescriptorsList.length) {
          console.log('Selected all prescribers');
          this.selectedAllEstablishments = true;
          this.loadEstablishmentCombo();
        } else {
          console.log('NO Selected all prescribers');
          if (this.searchDataForm.controls.prescriptor?.value.length < 1000) {
            this.selectedAllEstablishments = false;
            this.loadEstablishmentComboByPrescribers(request);
          }
        }
      }
    });

    this.validateMacroChainUser();
    if (this.isBusinessDirector) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN, FORM_PARAM_MACRO_OFFICE]);
    else if (this.isMacroChainUser) this.initMacroUsers([FORM_PARAM_MACRO_CHAIN]);
    else if (this.isMacroOfficeUser) this.initMacroUsers([FORM_PARAM_MACRO_OFFICE]);
    else {
      this.selectedAllPrescribers = true;
      this.selectedAllEstablishments = true;
      this.loadPrescriptorCombo();
    }
    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    //load prescriptor combo
    this.loadPrescriptorCombo();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  private updateTableHeader(isPdf: boolean): string[][] {
    return [
      [
        this.translateService.instant('paymentReports.table.paymentDate'),
        this.translateService.instant('paymentReports.table.lot'),
        this.translateService.instant('paymentReports.table.request'),
        this.translateService.instant('paymentReports.table.contract'),
        this.translateService.instant('paymentReports.table.establishment'),
        this.translateService.instant('paymentReports.table.company'),
        this.translateService.instant('paymentReports.table.nifCif'),
        this.translateService.instant('paymentReports.table.beneficiary'),
        this.translateService.instant('paymentReports.table.amount'),
        this.translateService.instant('paymentReports.table.transferred'),
        ...(!isPdf ? [this.translateService.instant('paymentReports.table.financialCosts')] : []),
        this.translateService.instant('paymentReports.table.nameHolder'),
        this.translateService.instant('paymentReports.table.description'),
        this.translateService.instant('paymentReports.table.reference'),
        this.translateService.instant('paymentReports.table.reference2'),
        this.translateService.instant('paymentReports.table.shopId'),
        this.translateService.instant('paymentReports.table.operative'),
      ],
    ];
  }

  public onSearchClick(page: number) {
    this.page = page;
    this.dataSource.data = [];
    const request = {
      dateFrom: this.datePipe.transform(this.searchDataForm.controls.initialDate.value, 'yyyy-MM-dd'),
      dateTo: this.datePipe.transform(this.searchDataForm.controls.finalDate.value, 'yyyy-MM-dd'),
      establishmentIds: this.searchDataForm.controls.establishment.value,
      prescriberIdList: this.searchDataForm.controls.prescriptor.value,
      isAllCheck: this.isCheckAllEstablishment && this.isCheckAllPrescriber,
      pageIndex: this.page,
      pageSize: this.pageSize,
      chainId: this.chainId,
      officeId: this.officeId,
    };
    this.searchParamsExcel = request;
    new Promise<void>((res, rej) => {
      this.activityStore
        .getPaymentReports(request)
        .then(
          (result) => {
            if (result && result.results.length > 0) {
              this.reports = result;

              //esto se ha hecho porque la tabla de la bbdd está medio vacía y a la hora de cargar excel y pdf se quedan medio vacíos y las columnas se cambian
              this.reports.results.forEach((element) => {
                element.establishment = element.establishment ? element.establishment : '';
                element.paymentDate = element.paymentDate
                  ? this.datePipe.transform(element.paymentDate, 'dd-MM-yyyy')
                  : '';
                element.recipient = element.recipient ? element.recipient : '';
                element.amount = element.amount ? element.amount : 0;
                element.transferred = element.transferred ? element.transferred : 0;
                element.item = element.item ? element.item : '';
                element.titleholder = element.titleholder ? element.titleholder : '';
                element.description = element.description ? element.description : '';
                element.contractId = element.contractId ? element.contractId : '';
                element.dtoCommercial = element.dtoCommercial ? element.dtoCommercial : 0;
                element.reference = element.reference ? element.reference : '';
                element.idOwnStoreAgreement = element.idOwnStoreAgreement ? element.idOwnStoreAgreement : '';
                element.lot = element.lot ? element.lot : '';
              });
            } else {
              this.reports.results = [];
            }
            this.dataSource.data = this.reports.results;
            res();
          },
          (error) => {
            if (!error.error.message.includes('no.data.found')) {
              console.error(error);
              this.showDialogError('Error desconocido');
            }
            this.reports = {
              amountTotal: 0,
              realizedPayments: 0,
              results: [],
              numPages: 0,
              pageIndex: 1,
              pageSize: this.pageSize,
              isPageable: false,
              chainId: '',
              officeId: '',
            };
          }
        )
        .catch((error) => {
          console.error(error);
          this.showDialogError('Error desconocido');
          this.reports = {
            amountTotal: 0,
            realizedPayments: 0,
            results: [],
            numPages: 0,
            pageIndex: 1,
            pageSize: this.pageSize,
            isPageable: false,
            chainId: '',
            officeId: '',
          };
        })
        .finally(() => {
          this.cdref.detectChanges();
          this.dataSource.paginator = this.paginator;
          this.dataSource.data = this.reports.results;
          this.allData = this.reports.results;
          console.log(this.reports.results);
        });
    });
  }

  isAllChecked() {
    if (this.isCheckAllEstablishment || this.isCheckAllPrescriber) {
      return true;
    }
    return false;
  }

  public onClickPrintPayment(element: PaymentReport) {
    new Promise<void>((res, rej) => {
      this.activityStore.getPdfPaymentReport(element.numOperation, this.translateService.currentLang).then(
        (result) => {
          if (result) {
            if (this.translateService.currentLang === SPANISHLANGUAGE) {
              this.openPDFOnSuccess(result, NAMEPAYMENTSHEETSPANISH + this.datePipe.transform(Date.now(), 'ddMMyyyy'));
            } else {
              this.openPDFOnSuccess(result, NAMEPAYMENTSHEETCATALAN + this.datePipe.transform(Date.now(), 'ddMMyyyy'));
            }
          }
          res(result);
        },
        (error) => {
          res(error);
        }
      );
    });
  }

  public openPDFOnSuccess(data: any, title: string) {
    let file = new Blob([data], { type: 'application/pdf' });
    FileSaver.saveAs(file, title + '.pdf');
  }

  public createExcel() {
    let allDataExcel: dataPrint = { headers: this.head[0], data: this.reports.results };
    let credentials = JSON.parse(localStorage.getItem('credentials'));
    const excelAllData = {
      searchData: this.searchParamsExcel,
      data: allDataExcel,
      realizedPayments: this.reports.realizedPayments,
      amountTotal: this.reports.amountTotal,
      division: credentials.division,
    };
    this.excelService.exportExcelPaymentReport(excelAllData);
  }

  public createPdf() {
    try {
      let doc = new jsPDF({
        orientation: 'landscape',
        format: [360, 209],
      });

      const date = moment().locale('es');
      const filename = this.translateService.instant('paymentReports.table.pdfTitle') + date.format('DDMMYYYY');

      doc.setProperties({
        title: filename,
      });
      let dataColumns: string[] = [
        'paymentDate', //fecha pago
        'lot',
        'numOperation',
        'contractId', //referencia¿?
        'establishment',
        'company',
        'cifBeneficiary', //NIF/CIF beneficiario
        'recipient', //beneficiario / destinatario
        'netAmount',
        'amount',
        'financialExpenses', //importe
        'titleholder', //titular
        'description', //descripcion
        'reference', //campo referencia
        'reference2',
        'idOwnStoreAgreement', //id_tienda
        'operative',
      ];
      let dataPdf: any[] = [];
      let credentials = JSON.parse(localStorage.getItem('credentials'));
      if (credentials.division.toString() === FINANCIAL_PRODUCT_AUTO) {
        this.head = this.updateTableHeader(true);
        dataColumns = dataColumns.filter((e) => e != 'financialExpenses');
      }

      // BODY
      this.reports?.results.forEach((item) => {
        const dataPdfOrder = JSON.stringify(item, dataColumns);
        const ObjectDataPdf = JSON.parse(dataPdfOrder);
        dataPdf.push(ObjectDataPdf);
      });

      dataPdf.push({
        establishment: 'TOTAL PAGOS:',
        paymentDate: this.reports.realizedPayments,
        recipient: 'TOTAL:',
        transferred: this.reports.amountTotal,
        titleholder: '',
        description: '',
        lot: '',
        amountTotalFinancial: '',
        amountGoodFinancial: '',
        dtoCommercial: '',
        netAmount: '',
        reference: '',
        idOwnStoreAgreement: '',
        financialExpenses: '',
      });

      autoTable(doc, {
        startY: 55,
        head: this.head,
        headStyles: { fillColor: '#969696', fontSize: 8 },
        rowPageBreak: 'avoid',
        showHead: 'everyPage',
        margin: { top: 55 },
        body: dataPdf.map(Object.values),
        didDrawPage: (data) => {
          /* HEADER */
          doc.setFontSize(24);
          doc.setTextColor('1E90FF');
          doc.text(this.translateService.instant('paymentReports.title'), 160, 25);
          doc.setTextColor('#000000');
          doc.setFontSize(16);
          doc.text(this.translateService.instant('paymentReports.title'), 14, 52);
          doc.setFontSize(11);

          doc.text(
            'De ' +
              this.datePipe.transform(this.searchDataForm.controls.initialDate.value, 'dd/MM/yyyy') +
              ' a ' +
              this.datePipe.transform(this.searchDataForm.controls.finalDate.value, 'dd/MM/yyyy'),
            110,
            37
          );
          doc.text(
            this.translateService.instant('paymentReports.table.date') +
              moment().locale('es').format('DD-MM-YYYY HH:mm:ss'),
            220,
            37
          );

          doc.text(this.translateService.instant('paymentReports.table.page') + data.pageNumber, 220, 45);

          let img = new Image();
          img.src = 'assets/img/logo.PNG';
          doc.addImage(img, 'png', 3, 10, 80, 30);
        },
      });

      let blob = doc.output('blob');
      FileSaver.saveAs(blob, filename);
      window.open(URL.createObjectURL(blob));
    } catch (error) {
      console.error(error);
    }
  }

  private showDialogError(error: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  toggleAllEstablishmentsSelection = () => {
    this.loaderGenericService.showSpinner();
    this.isCheckAllEstablishment = this.selectedAllEstablishments;
    if (this.selectedAllEstablishments) {
      this.searchDataForm.controls.establishment.setValue(
        this.establishmentsList.map((establishment) => establishment.id)
      );
    } else {
      this.searchDataForm.controls.establishment.setValue(['']);
    }
    this.loaderGenericService.stopSpinner();
  };

  checkSelectAllEstablishments = () => {
    this.selectedAllEstablishments = this.selectedAllEstablishments
      ? false
      : this.searchDataForm.get('establishment')?.value.length === this.establishmentsList.length;
  };

  toggleAllPrescribersSelection = () => {
    this.loaderGenericService.showSpinner();
    this.isCheckAllPrescriber = this.selectedAllPrescribers;
    this.selectedAllPrescribers
      ? this.searchDataForm.controls.prescriptor.setValue(this.prescriptorsList.map((prescriptor) => prescriptor.id))
      : this.searchDataForm.controls.prescriptor.setValue(['']);
    this.loaderGenericService.stopSpinner();
  };

  checkSelectAllPrescribers = () => {
    this.selectedAllPrescribers = this.selectedAllPrescribers
      ? false
      : this.searchDataForm.get('prescriber')?.value.length === this.prescriptorsList.length;
  };

  private loadEstablishmentComboByPrescribers = async (filter?: any) => {
    this.loaderGenericService.showSpinner();
    this.searchDataForm.controls.establishment.setValue('');
    this.showSelectAllCheckboxEstablishment = false;
    this.establishmentsList = [];
    this.combosStore
      .getEstablishmentsByPrescribers(filter)
      .then(
        (result) => {
          if (result) {
            this.establishmentsList = result;

            if (result.length === 1) {
              this.showSelectAllCheckboxEstablishment = false;
              this.searchDataForm.controls.establishment.setValue(new Array(result[0]?.id));
            } else {
              this.showSelectAllCheckboxEstablishment = true;
              this.searchDataForm.controls.establishment.setValue(
                this.establishmentsList.map((establishment) => establishment.id)
              );
            }
          }
        },
        (error) => console.log(error)
      )
      .catch((error) => console.log(error))
      .finally(() => this.loaderGenericService.stopSpinner());
  };

  private loadEstablishmentCombo = async () => {
    this.loaderGenericService.showSpinner();
    this.searchDataForm.controls.establishment.setValue('');
    this.showSelectAllCheckboxEstablishment = false;
    this.establishmentsList = [];
    const request = this.buildFilterRequest();
    if (request.officeId == null) {
      this.officeId = '';
      this.chainId = request.chainId;
    } else if (request.chainId == null) {
      this.officeId = request.officeId;
      this.chainId = '';
    }
    this.combosStore
      .getEstablishments(request)
      .then(
        (result) => {
          if (result) {
            this.establishmentsList = result;
            if (result.length === 1) {
              this.showSelectAllCheckboxEstablishment = false;
              this.searchDataForm.controls.establishment.setValue(new Array(result[0]?.id));
            } else {
              this.isCheckAllEstablishment = true;
              this.showSelectAllCheckboxEstablishment = true;
              if (this.selectedAllEstablishments)
                this.searchDataForm.controls.establishment.setValue(
                  this.establishmentsList.map((establishment) => establishment.id)
                );
            }
          }
        },
        (error) => console.log(error)
      )
      .catch((error) => console.log(error))
      .finally(() => this.loaderGenericService.stopSpinner());
  };

  private buildFilterRequest = () => {
    let request;
    if (this.isBusinessDirector) {
      request = this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].value
        ? { chainId: this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN }
        : { officeId: this.searchDataForm.controls[FORM_PARAM_MACRO_OFFICE].value, userType: OFFICE_DIRECTOR };
    } else if (this.isMacroChainUser)
      request = { chainId: this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].value, userType: CHAIN };
    else if (this.isMacroOfficeUser)
      request = { officeId: this.searchDataForm.controls[FORM_PARAM_MACRO_OFFICE].value, userType: OFFICE_DIRECTOR };
    else request = {};
    return request;
  };
  private loadPrescriptorCombo = async () => {
    this.loaderGenericService.showSpinner();
    this.showSelectAllCheckboxPresciber = false;
    this.emptyPrescriberEstablishmentCombo();
    const request = this.buildFilterRequest();
    this.combosStore
      .getPrescribers(request)
      .then(
        (result) => {
          if (result) {
            this.prescriptorsList = result;

            if (result.length === 1) {
              this.showSelectAllCheckboxPresciber = false;
              this.searchDataForm.controls.prescriptor.setValue(new Array(result[0]?.id));
            } else {
              this.isCheckAllPrescriber = true;
              this.showSelectAllCheckboxPresciber = true;
              if (this.selectedAllPrescribers)
                this.searchDataForm.controls.prescriptor.setValue(
                  this.prescriptorsList.map((prescriptor) => prescriptor.id)
                );
            }
          }
        },
        (error) => console.log(error)
      )
      .catch((error) => console.log(error));
  };

  private loadMacroChains = async () => {
    this.resetPrescribersEstablishments();
    this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].setValue('');
    this.macroChainList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getChainsByDivision(this.userInfo.division?.toString())
      : this.combosStore.getChainsFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroChainList =
              this.isBusinessDirector && data.length > 0 ? [{ id: undefined, value: '' }, ...data] : [...data];
            if (this.macroChainList.length === 1)
              this.searchDataForm.controls[FORM_PARAM_MACRO_CHAIN].setValue(this.macroChainList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => {
        if (error) {
          console.error(error);
          this.showDialogError(error);
        }
      });
  };

  private loadMacroOffices = async () => {
    this.resetPrescribersEstablishments();
    this.searchDataForm.controls[FORM_PARAM_MACRO_OFFICE].setValue('');
    this.macroOfficeList = [];
    const promise = this.isBusinessDirector
      ? this.combosStore.getOfficesByDivision(this.userInfo.division?.toString())
      : this.combosStore.getOfficesFromMacroUser(this.userInfo.userId);
    promise
      .then(
        (data) => {
          if (data) {
            this.macroOfficeList =
              this.isBusinessDirector && data.length > 0 ? [{ id: undefined, value: '' }, ...data] : [...data];
            if (this.macroOfficeList.length === 1)
              this.searchDataForm.controls[FORM_PARAM_MACRO_OFFICE].setValue(this.macroOfficeList[0]?.id);
          }
        },
        (error) => console.error(error)
      )
      .catch((error) => {
        if (error) {
          console.error(error);
          this.showDialogError(error);
        }
      });
  };

  isEstablishmentGenericSelect() {
    return this.establishmentsList?.length < MAX_SELECTOR_DATA;
  }

  isPrescriptorGenericSelect() {
    return this.prescriptorsList?.length < MAX_SELECTOR_DATA;
  }

  private validateMacroChainUser = () => {
    this.isMacroChainUser = this.userInfo.userType === MACRO_CHAIN;
    this.isMacroOfficeUser = this.userInfo.userType === MACRO_OFFICE;
    this.isBusinessDirector = this.userInfo.userType === BUSINESS_DIRECTOR;
  };

  private emptyPrescriberEstablishmentCombo = () => {
    this.prescriptorsList = [];
    this.establishmentsList = [];
    this.searchDataForm.controls.prescriptor.setValue('');
    this.searchDataForm.controls.establishment.setValue('');
  };

  private resetPrescribersEstablishments = () => {
    this.emptyPrescriberEstablishmentCombo();
    if (this.searchDataForm) {
      this.searchDataForm.controls.prescriptor?.setValue('');
      this.searchDataForm.controls.establishment?.setValue('');
    }
  };

  private initMacroUsers = (formProperties: string[]) => {
    this.disableFormControls();
    formProperties.forEach((property) => {
      this.searchDataForm.addControl(property, new FormControl('', Validators.required));
      this.initValueChangesMacroUser(property);
      if (property === FORM_PARAM_MACRO_CHAIN) this.loadMacroChains();
      else if (property === FORM_PARAM_MACRO_OFFICE) this.loadMacroOffices();
    });
  };

  private initValueChangesMacroUser = (property: string) => {
    this.selectedAllPrescribers = true;
    this.selectedAllEstablishments = true;

    this.searchDataForm.controls[property].valueChanges.subscribe((value) => {
      if (value) {
        this.loadPrescriptorCombo();
        if (this.isBusinessDirector)
          this.disableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.enableFormControls();
      } else {
        this.establishmentsList = [];
        this.prescriptorsList = [];
        if (this.isBusinessDirector)
          this.enableFormControl(
            property === FORM_PARAM_MACRO_CHAIN ? FORM_PARAM_MACRO_OFFICE : FORM_PARAM_MACRO_CHAIN
          );
        this.disableFormControls();
      }
    });
  };

  private enableFormControl = (param: string) => {
    if (param) {
      const form = this.searchDataForm.controls;
      if (form[param]?.disabled) form[param].enable();
    }
  };

  private disableFormControl = (param: string) => {
    if (param) {
      const form = this.searchDataForm.controls;
      if (form[param]?.enabled) {
        if (form[param].value) form[param].setValue('');
        form[param].disable();
      }
    }
  };

  private disableFormControls = () => {
    if (this.searchDataForm) {
      Object.keys(this.searchDataForm.controls).forEach((key) => {
        if (key !== FORM_PARAM_MACRO_CHAIN && key !== FORM_PARAM_MACRO_OFFICE) {
          this.searchDataForm.controls[key].setValue('');
          if (this.searchDataForm.controls[key].enabled) {
            this.searchDataForm.controls[key].disable();
          }
        }
      });
    }
  };

  private enableFormControls = () => {
    if (this.searchDataForm) {
      Object.keys(this.searchDataForm.controls).forEach((key) => {
        if (
          key !== FORM_PARAM_MACRO_CHAIN &&
          key !== FORM_PARAM_MACRO_OFFICE &&
          this.searchDataForm.controls[key].disabled
        ) {
          this.searchDataForm.controls[key].enable();
        }
      });
    }
  };

  setCheckAll(event: { id: string; value: boolean }) {
    const { id, value } = event;
    switch (id) {
      case 'prescriptorSelect':
        this.isCheckAllPrescriber = value;
        break;
      case 'establishmentSelect':
        this.isCheckAllEstablishment = value;
        break;
      default:
        console.error('setCheckAll - NOT FOUND', id);
    }
  }

  sendDateMonth(event: any) {
    if (event.checked === true) {
      this.searchDataForm.controls.initialDate.setValue(moment().startOf('month').format('YYYY-MM-DD'));
      this.searchDataForm.controls.initialDate.disable();
      this.searchDataForm.controls.finalDate.setValue(moment());
      this.searchDataForm.controls.finalDate.disable();
      this.checkedDateMonth = true;
    } else {
      this.searchDataForm.controls.initialDate.reset();
      this.searchDataForm.controls.finalDate.reset();
      this.searchDataForm.controls.initialDate.enable();
      this.searchDataForm.controls.finalDate.enable();
      this.checkedDateMonth = false;
    }
  }
}
